import React from "react";
import PropTypes from "prop-types";
import { LineTruncate, Text, Triangle, ContentContainerAtom, Link } from "../../../atoms";
import ImageWrapper from "../../ImageWrapper";
import styled from "styled-components";

const Default = ({
  className,
  onKeyDown,
  onKeyPress,
  href,
  native,
  data,
  ariaLabel,
  alt,
  onMouseMove,
  text,
  title,
  styles,
  theme
}) => {
  return (
    <ContentContainerAtom
      className={className}
      position="relative"
      onKeyDown={onKeyDown}
      onKeyPress={onKeyPress}
    >
      <Link
        href={href}
        rel="noopener noreferrer"
        tabIndex={0}
        display="block"
        hasHover={false}
        native={native}
      >
        <ImageWrapper
          data={data}
          aria-label={ariaLabel}
          alt={alt}
          hasEndpoint={false}
          onMouseMove={onMouseMove}
          endpoint={() => null}
          size="lg"
          useHeight
        />
        <ContentContainer
          backgroundColor={
            theme.highContrast.backgroundColor || styles.backgroundColor
          }
          paddingTop="20px"
          paddingBottom="20px"
          mdPaddingTop="20px"
          position="absolute"
          width="100%"
          bottom="0"
        >
          <div className="container">
            <Triangle
              withContent={true}
              contentColor={theme.highContrast.text || styles.textColor}
              color={
                theme.highContrast.backgroundColor || styles.backgroundColor
              }
              size="40px"
              top="-60px"
              right="15px"
              contentSize="50px"
              XsContentSize="40px"
              XsSize="30px"
              XsTop="-50px"
            />
            <LineTruncate>
              <Text
                text={text}
                color={theme.highContrast.text || styles.textColor}
                fontSize="16px"
                mobileXsFontSize="14px"
              />
            </LineTruncate>
            <Text
              as="h3"
              size="xxLarge"
              sizeXsSize="large"
              fontWeight="500"
              color={theme.highContrast.text || styles.textColor}
              lineHeight="1.5"
            >
              {title}
            </Text>
          </div>
        </ContentContainer>
      </Link>
    </ContentContainerAtom>
  );
};

Default.propTypes = {
  className: PropTypes.string,
  onKeyDown: PropTypes.func,
  onKeyPress: PropTypes.func,
  href: PropTypes.string,
  native: PropTypes.bool,
  data: PropTypes.array,
  ariaLabel: PropTypes.string,
  alt: PropTypes.string,
  onMouseMove: PropTypes.func,
  text: PropTypes.string,
  title: PropTypes.string,
  styles: PropTypes.object,
  theme: PropTypes.object
};

const DefaultWithStyles = styled(Default)`
  //For the button
  .container {
    position: relative;
  }
`;

export default DefaultWithStyles;
